"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROBLEMATIC_PHONE_NUMBER_STATUS = void 0;
/**
 * Problematic Phone number status
 */
var PROBLEMATIC_PHONE_NUMBER_STATUS;
(function (PROBLEMATIC_PHONE_NUMBER_STATUS) {
    PROBLEMATIC_PHONE_NUMBER_STATUS["WARNING"] = "WARNING";
    PROBLEMATIC_PHONE_NUMBER_STATUS["BLOCKED"] = "BLOCKED";
})(PROBLEMATIC_PHONE_NUMBER_STATUS || (exports.PROBLEMATIC_PHONE_NUMBER_STATUS = PROBLEMATIC_PHONE_NUMBER_STATUS = {}));
